import { cn } from '../../lib/styles';

export interface PageHeaderTitleProps {
  children: React.ReactNode;
  subTitle?: React.ReactNode;
  className?: string;
  suffix?: React.ReactNode;
}

export const PageHeaderTitle = ({ children, subTitle, className, suffix }: PageHeaderTitleProps) => {
  const titleElement =
    typeof children === 'string' ? (
      <h1 data-slot="title" className={cn('text-text-primary font-heading-2xl font-semibold truncate', className)}>
        {children}
      </h1>
    ) : (
      children
    );

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-3">
        {titleElement}

        {suffix && (typeof suffix === 'string' || typeof suffix === 'number') ? (
          <span
            data-slot="title-suffix"
            className="text-text-tertiary font-body-sm font-semibold mt-0.5 whitespace-nowrap"
          >
            {suffix}
          </span>
        ) : (
          suffix
        )}
      </div>

      {subTitle ? <div className="text-text-secondary font-body-sm truncate">{subTitle}</div> : null}
    </div>
  );
};
